/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { useUserId } from '@/api/hooks';
import { startMetrics, updateMetrics } from '@/api/metrics';

/** Records session login metrics and appends the current URL on each navigation. Failures are ignored. */
export function useMetricsTracking(): void {
  const userId = useUserId();
  const { pathname, search } = useLocation();
  const startedRef = useRef(false);

  // Create the login row once the user is known, then record the entry URL.
  useEffect(() => {
    if (!userId || startedRef.current) return;
    startedRef.current = true;
    void startMetrics(userId, [window.location.href], new Date().toISOString())
      .then(() => updateMetrics(userId, window.location.href))
      .catch(() => {});
  }, [userId]);

  // updateMetrics no-ops until startMetrics has cached an id.
  useEffect(() => {
    if (!userId) return;
    void updateMetrics(userId, window.location.href).catch(() => {});
  }, [userId, pathname, search]);
}
